import { useEffect, useState } from "react";
import { ContentCatalogService } from "@services/contentCatalog/ContentCatalogService";

/*
    Template names for a grid of ads, fetched once per set of ids (MPN-1508).

    Kept out of the ad payload on purpose: the same payload is served to client reviewers,
    who must never see the template an ad was rebranded from. The server decides per viewer,
    so this is safe to call from anywhere; a caller with no access simply gets nothing back.
*/
export function useAdProvenance(adIds: number[]): Record<number, string> {
  const [names, setNames] = useState<Record<number, string>>({});
  const key = adIds.join(",");

  useEffect(() => {
    let cancelled = false;
    if (adIds.length === 0) {
      setNames({});
      return;
    }
    void new ContentCatalogService()
      .getAdProvenance(adIds)
      .then((result) => {
        if (!cancelled) setNames(result);
      })
      .catch(() => {
        // Provenance is a label, not the content. A failure here leaves the cards as they
        // were rather than taking the catalog down with it.
        if (!cancelled) setNames({});
      });
    return () => {
      cancelled = true;
    };
     
  }, [key]);

  return names;
}
